// css
import '../css/main.less';

// polyfills
import 'babel-polyfill';
import 'element-closest';
import './polyfill';

import './windowExports';

// source
import './web';
import './configureWeb';
import './configurePartialUpdate';
//import './configureTurbolinks';




// WEBPACK FOOTER //
// ./fe/web-3dliving/src/js/index.js